import { render, staticRenderFns } from "./TrackSlider.vue?vue&type=template&id=1aef81b4&scoped=true"
import script from "./TrackSlider.vue?vue&type=script&lang=js"
export * from "./TrackSlider.vue?vue&type=script&lang=js"
import style0 from "./TrackSlider.vue?vue&type=style&index=0&id=1aef81b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef81b4",
  null
  
)

export default component.exports